export class Logout {
  static readonly type = '[AuthenticationState] Logout';
}
